<!-- /src/components/common/Downloadable.vue -->
<template>
  <div v-if="file" class="downloadable">
    <div class="downloadable__itemWrap">
    <router-link
      v-if="isSecure"
      :to="{ name: 'pdfViewer', params:{ path: url } }"
        class="downloadable__item">
        <i
          v-if="icon.iconType == 'fontawesome'"
          class="downloadable__itemIcon"
          :class="icon.cssClass"
        />
        <img v-else
          class="downloadable__itemImage"
          :class="icon.cssClass"
          :src="icon.imgSrc"
        />

        <span class="downloadable__itemTitle">{{ title }}</span>
        <div class="downloadable__itemAction">
          <i
            class="downloadable__itemAction__icon fal fa-cloud-download"
          />
        </div>
    </router-link>
    <a v-else
      class="downloadable__item" :href="url" target="_blank" download>
        <i
          v-if="icon.iconType == 'fontawesome'"
          class="downloadable__itemIcon"
          :class="icon.cssClass"
        />
        <img v-else
          class="downloadable__itemImage"
          :class="icon.cssClass"
          :src="icon.imgSrc"
        />

        <span class="downloadable__itemTitle">{{ title }}</span>
        <div class="downloadable__itemAction">
          <i
            class="downloadable__itemAction__icon fal fa-cloud-download"
          />
        </div>
      </a>
      <div class="downloadable__itemDesc" v-if="caption" v-html="caption"></div>
    </div>
  </div>
</template>

<script>

import * as pdfjs from "pdfjs-dist/legacy/build/pdf";
import {PDFViewer} from "pdfjs-dist/legacy/web/pdf_viewer";
// import "pdfjs-dist/legacy/web/pdf_viewer.css";


// import "pdfjs-dist/web/pdf_viewer.css";

pdfjs.GlobalWorkerOptions.workerSrc = "https://cdn.jsdelivr.net/npm/pdfjs-dist@2.14.305/build/pdf.worker.min.js";

export default {
  props: {
    file: {
      type: Object,
      required: true,
    },
    isSecure: {
      type: Boolean,
    },
  },

  computed: {
    url() {
      const { url } = this.file
      return url ? url : false
    },

    base() {
      const { url } = this.file
      return url ? url : false
    },

    title() {
      const { title } = this.file
      return title ? title : false
    },

    caption() {
      const { caption } = this.file
      return typeof caption != 'undefined' && caption.trim() ? caption : false
    },

    extension() {
      const { file } = this
      const re = /(?:\.([^.]+))?$/
      return re.exec(file.filename)[1]
    },

    mimeType() {
      const { file } = this
      return file['mime_type'] && typeof file['mime_type'] != 'undefined' ? file['mime_type'] : false
    },

    icon() {
      const { extension } = this
      const fonticon = 'fas ';
      let cssClass = false
      let iconType = false
      let imgSrc = false
      switch (extension) {
        case 'pdf':
          cssClass = 'image'
          iconType = 'image'
          imgSrc = '/wp-content/themes/carr_edu_vue/src/assets/adobe_pdf_icon.svg'
          break
        case 'eps':
          cssClass = fonticon + 'fa-bezier-curve'
          iconType = 'fontawesome'
          break
        case 'doc':
        case 'docx':
        case 'dotm':
        case 'dotx':
          cssClass = 'downloadImage fa-file-word'
          iconType = 'image'
          imgSrc = '/wp-content/themes/carr_edu_vue/src/assets/ms_doc_icon.svg'
          break
        case 'rtf':
        case 'txt':
          cssClass = fonticon + 'fa-align-left'
          iconType = 'fontawesome'
          break
        case 'ods':
        case 'xls':
        case 'xlsx':
        case 'xlsm':
        case 'xltm':
        case 'xltx':
          cssClass = 'fa-file-spreadsheet'
          iconType = 'image'
          imgSrc = '/wp-content/themes/carr_edu_vue/src/assets/ms_xls_icon.svg'
          break
        case 'pptx':
        case 'ppsx':
        case 'pptm':
        case 'ppt':
          cssClass = 'fa-file-powerpoint'
          iconType = 'image'
          imgSrc = '/wp-content/themes/carr_edu_vue/src/assets/ms_ppt_icon.svg'
          break
        case 'zip':
        case 'gzip':
          cssClass = fonticon + 'fa-file-archive'
          iconType = 'fontawesome'
          break
        case 'csv':
          cssClass = fonticon + 'fa-file-csv'
          iconType = 'fontawesome'
          break
        case 'mp4':
        case 'm4a':
        case 'mov':
        case 'webm':
        case 'flv':
        case 'ogg':
          cssClass = fonticon + 'fa-video'
          iconType = 'fontawesome'
          break
        case 'mp4':
        case 'm4a':
        case 'mov':
        case 'webm':
        case 'flv':
        case 'ogg':
          cssClass = fonticon + 'fa-microphone-alt'
          iconType = 'fontawesome'
          break
        case 'png':
        case 'tif':
        case 'jpg':
        case 'jpeg':
        case 'gif':
          cssClass = 'far fa-image-polaroid'
          iconType = 'fontawesome'
          break
        case 'eml':
        case 'emltpl':
        case 'msg':
          cssClass = 'fa-envelope-open-text'
          iconType = 'image'
          imgSrc = '/wp-content/themes/carr_edu_vue/src/assets/ms_eml_icon.svg'
          break
        default:
          cssClass = fonticon + 'fa-file-exclamation'
          iconType = 'fontawesome'
      }
      return {
        cssClass,
        iconType,
        imgSrc,
      }
    },
  },

  methods: {

  },
}
</script>

<style scoped>
.downloadable {

  &__item {
    align-items: center;
    background-color: white;
    color: var(--brandPrimary);
    padding: 0.5rem 1rem;
    position: relative;
    border-radius: 4px;
    text-decoration: none !important;
    font-weight: 500;
    display: grid;
    grid-gap: .5rem;
    transition: .2s all;
    grid-template-columns: auto 1fr auto;

    &:hover {
      color: white;
      background-color: var(--brandAccent);
    }

    /* @media (--desktop) {
      display: flex;
    } */

    &Wrap {
    }

    &Icon {
      font-size: 1.5em;
      width: 2rem;
      display: grid;
      height: 2rem;
      justify-content: center;
      align-content: center;
      
      /* position: absolute; */
      @media (--desktop) {
        margin: 0;
        position: relative;
      }
    }

    &Image {
      width: 2rem;
    }

    &Title {
      align-self: center;
      text-align: left;
      font-size: 1rem;
      line-height: 1;
    }

    &Desc {
      font-size: 0.8rem;
      margin: .5rem 2rem;
      /* margin-bottom: 1rem; */
    }

    &Action {
      color: inherit;
      text-transform: uppercase;
      font-weight: var(--fontWeightExtraBold);
      font-size: 0.6rem;
      align-items: center;
      /* height: 100%; */

      &__icon {
        font-size: 1.8em;
        display: inline-block;
        margin-right: 0.5em;
      }
    }
  }
}
</style>
